<template src="./Config.html"></template>

<script>
import { createNamespacedHelpers } from 'vuex';
import TopMenu from "@/components/settings/components/topMenu"

const { mapGetters, mapActions} = createNamespacedHelpers('settings/config');

export default {
  name: "Config",
  components: {
    TopMenu,
  },
  data () {
    return {
      showOverlay: false,
      type: 'ru',
      fieldsList: [
        {
          key: 'id',
          label: '-',
          sortable: false,
          tdClass: 'action-cell',
          thClass: 'action-cell'
        },
        {
          key: 'name',
          label: 'Название',
          sortable: true
        },
        {
          key: 'value',
          label: 'Значение',
          sortable: true
        },
      ],
      currentPage: 1,
      currentSort: 'name',
      currentSortDir: true,
      searchVal: '',
      newRowValue: {},
      reComputed: false,
      renderComponent: true,
    }
  },
  methods: {
    ...mapActions([
      'GET_DATA',
      'SAVE',
    ]),
    initPageSize: function () {
      let winHeight = window.innerHeight;
      winHeight = Math.round((winHeight - 205) / 26);
      this.$store.commit('settings/config/PER_PAGE', winHeight);
      this.currentPage = 1;
    },
    editCell: function (id, field) {
      let viewCell = this.$refs.dictionaryTable.$el.querySelectorAll('.t-cell');
      viewCell.forEach((val) => {
        val.style.display = 'block';
      });

      let editCell  = this.$refs.dictionaryTable.$el.querySelectorAll('.edit-cell');
      editCell.forEach((val) => {
        val.style.display = 'none';
      })

      this.$refs['cell_view_' + id +'_'+ field].style.display = 'none';
      if (this.$refs['cell_edit_' + id +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + id +'_'+ field].style.display = 'block';
        this.$refs['cell_edit_' + id +'_'+ field].focus();
      } else {
        this.$refs['cell_edit_' + id +'_'+ field].$el.style.display = 'block';
        this.$refs['cell_edit_' + id +'_'+ field].$el.focus();
      }
    },
    changeCell: function (index, id, field) {
      this.$refs['cell_view_' + id +'_'+ field].style.display = 'block';
      if (this.$refs['cell_edit_' + id +'_'+ field].$el == undefined) {
        this.$refs['cell_edit_' + id +'_'+ field].style.display = 'none';
      } else {
        this.$refs['cell_edit_' + id +'_'+ field].$el.style.display = 'none';
      }
      // add new row
      if (this.CONFIG_DATA.length == (index + 1)) {
        let buf = this.CONFIG_DATA.splice(0);
        buf.push({
          id: '--',
          singularKey: '',
          singularValue: '',
          pluralKey: '',
          pluralValue: '',
          categoryName: '',
        });
        this.$store.commit('settings/config/CONFIG_DATA', buf);
        this.$forceUpdate();
      }
    },
    removeRow: function (id) {
      if (Number.isInteger(id)) {
        this.$store.commit('settings/config/ADD_TO_DELETED_LIST', id);
      }
      this.$store.commit('settings/config/DELETE_OF_CONFIG_DATA', id);
      this.reComputed = !this.reComputed
    },
    save: function () {
      this.SAVE({th: this});
    },
    addNew: function () {
      let key = 'new'+ Object.keys(this.CONFIG_DATA).length
      this.newRowValue['id'] = key
      this.$store.commit('settings/config/ADD_TO_CONFIG_DATA', {key: key, value: Object.assign({}, this.newRowValue)});
      this.reComputed = !this.reComputed
      this.initNewValue()
      this.forceRerender()
    },
    initNewValue: function () {
      this.newRowValue = null
      this.newRowValue = {}
      for (let key in this.getEditableFieldsList) {
        this.newRowValue[this.getEditableFieldsList[key].key] = null;
      }
    },
    forceRerender: function () {
      this.renderComponent = false
      this.$nextTick(() => (
          this.renderComponent = true
      ))
    }
  },
  computed: {
    ...mapGetters([
      'CONFIG_DATA',
      'CURRENT_PAGE',
      'PER_PAGE',
      'PARAMS',
    ]),
    getConfigData: function () {
      if (this.reComputed) {
        console.log('reComputed')
      }
      let buf = [];
      for(let key in this.CONFIG_DATA) {
        buf.push(this.CONFIG_DATA[key])
      }

      let search = this.searchVal.toLowerCase()
      buf = buf.filter((el) => {
        if (search.length == 0)
          return true

        let name = el.name.toLowerCase()
        let value = el.value.toLowerCase()
        return name.indexOf(search) !== -1 || value.indexOf(search) !== -1
      });

      return buf
    },
    getEditableFieldsList: function () {
      return this.fieldsList.filter((el) => {
        return el.key != 'id'
      })
    },
  },
  watch: {
    currentPage(newVal) {
      this.$store.commit('settings/config/CURRENT_PAGE', newVal);
    },
    type(newVal) {
      this.$store.commit('settings/config/SELECTED_TYPE', newVal);
    }
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('settings') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.currentPage = this.CURRENT_PAGE;
  },
  created() {
    this.initPageSize();
    if (Object.keys(this.CONFIG_DATA).length === 0) {
      this.GET_DATA({th: this});
    }
    // fill new value skeleton
    this.initNewValue()
  }
}
</script>

<style scoped>
  .dictionary-type {
    width: 77px;
    float: right;
  }
  .cell-cursor {
    cursor: cell;
  }
  .t-cell {
    overflow: hidden;
    width: 100%;
    display: block;
  }
  .remove-button {
    float: left;
    height: 24px;
    line-height: 15px;
  }
  .save-but {
    float: right;
  }
  .search-box {
    width: 500px;
    float: left;
  }
  .edit-cell {
    height: 24px;
    line-height: 15px;
  }
  .but-cell-plus {
    width: 25px !important;
    flex: 0 0 1%;
    padding-left: 0px;
  }
  .edit-cell-box {

  }
</style>

<style>
  .table td.action-cell, .table th.action-cell {
    width: 25px;
  }
</style>